import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

function LiveClock({ color }) {
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();

      const formattedTime = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(now);

      setCurrentTime(formattedTime);
      //   setTime(now.toLocaleTimeString());
    };

    updateClock(); // Initialize immediately
    const timer = setInterval(updateClock, 1000);

    return () => clearInterval(timer); // Cleanup timer on unmount
  }, []);

  return (
    <Typography
      variant="h4"
      sx={{
        width: '6rem',
        display: { xs: 'flex' },
        justifyContent: 'flex-start',
        // fontSize: '200',
        fontWeight: '600',
        color: color,
      }}>
      {currentTime}
    </Typography>
  );
}

export default LiveClock;
